import React from 'react';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, EndpointDoc, InfoCard } from '../../../components/apidocs';
import { SYSTEM_STATUS_ENDPOINTS } from '../data/systemStatus';

const SystemStatusSection: React.FC = () => (
  <div>
    <SectionTitle icon={faCogs} iconColor="bg-gradient-to-br from-violet-400 to-purple-500">
      System Status API
    </SectionTitle>
    <p className="text-gray-500 dark:text-slate-400 mb-5 text-sm">
      ดึงข้อมูลสถานะระบบ เช่น ระบบรับฝาก/ถอน/settlement เปิดอยู่หรือไม่ และยอดขั้นต่ำ
    </p>

    {SYSTEM_STATUS_ENDPOINTS.map((spec, idx) => <EndpointDoc key={idx} {...spec} />)}

    <InfoCard type="tip" title="แนะนำ">
      เรียก endpoint นี้ก่อนสร้าง Order หรือ Payout เพื่อตรวจสอบว่าระบบเปิดรับอยู่ และยอดที่ต้องการเป็นไปตามขั้นต่ำ
    </InfoCard>
  </div>
);

export default SystemStatusSection;
